import { useQuery } from '@tanstack/react-query';
import type { NetworkListItem } from './types';

export function useNetworks() {
    return useQuery({
        queryKey: ['ref-network-list'],
        queryFn: async () => (await (await fetch('/api/ref-network-list/networks')).json()) as { total: number; items: NetworkListItem[] },
    });
}
